import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { UnpaidDues } from "components/UnpaidDues/UnpaidDues";
import ReviveSubscription from "components/reviveSubscription/ReviveSubscription";
import { useDashboardBanner } from "hooks/useDashboardBanner";
import { useRoleBasedView } from "hooks/useRoleBasedView";

const stripePromise = loadStripe(process.env.PUBLIC_STRIPE_PUBLIC_KEY!);

export const DashboardBanner = () => {
  const { isCustomer } = useRoleBasedView();
  const {
    shouldRenderBanner,
    showReviveSubscription,
    showUnpaidDues,
    dueAmount,
  } = useDashboardBanner();

  if (!isCustomer || !shouldRenderBanner) {
    return null;
  }

  if (showReviveSubscription) {
    return (
      <div className="t-pb-3">
        <Elements stripe={stripePromise}>
          <ReviveSubscription />
        </Elements>
      </div>
    );
  }

  if (showUnpaidDues && dueAmount !== undefined) {
    return (
      <div className="t-pb-3">
        <UnpaidDues amount={dueAmount} />
      </div>
    );
  }

  return null;
};
